
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[identifier]",
      function () {
        return require("private-next-pages/events/[identifier].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[identifier]"])
      });
    }
  